// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1k-0";
export var spinnerContainer = "_1k-1";